// extracted by mini-css-extract-plugin
export var cOpenRight = "styles-module--cOpenRight--PTuz1";
export var container = "styles-module--container--Da-AV";